import { queryClient } from '@/query/queryClient'

export const CONVERSATION_SEARCH_KEY = ['do-chat', 'conversation-search']

export function conversationSearchKey({ workspaceId, workspaceScope, facet, q }) {
  return [...CONVERSATION_SEARCH_KEY, workspaceId, workspaceScope, facet, q]
}

export function invalidateConversationSearch() {
  queryClient.invalidateQueries({ queryKey: CONVERSATION_SEARCH_KEY })
}
